/** Mirrors metrika collect_app_controller::PROVIDER_ACTIONS */
export const PROVIDER_ACTIONS = {
    internal: [
        'hotel_view',
        'open_order_page',
        'open_hotel_order_page',
        'open_apartment_order_page',
        'order_submit',
        'order_success',
        'rr_queue_push',
        'rr_on_ready',
        'google_event_called',
        'yandex_reach_goal_called',
        'yandex_hit_called',
        'mailru_reach_goal_called',
        'retail_category_view_called',
    ],
    retail: ['view', 'addToBasket', 'order', 'setProfile', 'categoryView'],
    yandex: ['reachGoal', 'purchase'],
    google: ['event'],
    mailru: ['reachGoal'],
};

export const METRIC_STATUSES = ['intent', 'called', 'error', 'skipped'];

/** Временно отключить отправку на metrika.privettur.ru */
export const COLLECT_ENABLED = false;

export const DEFAULT_COLLECT_URL = 'https://metrika.privettur.ru/collect/';
export const DEFAULT_HEALTH_URL = 'https://metrika.privettur.ru/collect/health/';
export const DEFAULT_HEALTH_FLUSH_DELAY_MIN_MS = 3000;
export const DEFAULT_HEALTH_FLUSH_DELAY_MAX_MS = 5000;
export const DEFAULT_HEALTH_FLUSH_THRESHOLD = 50;

export const MAX_EVENTS_PER_REQUEST = 50;
export const MAX_HEALTH_CHECKS_PER_REQUEST = 50;

/** @deprecated Batching disabled; flush runs after each track (same-turn events are coalesced). */
export const DEFAULT_FLUSH_THRESHOLD = 1;

export const VISITOR_ID_STORAGE_KEY = 'metrika_visitor_id';
